import { render, staticRenderFns } from "./FinalizacaoDadosBasicos.vue?vue&type=template&id=4cd88891"
import script from "./FinalizacaoDadosBasicos.vue?vue&type=script&lang=js"
export * from "./FinalizacaoDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports